/* eslint-disable indent */
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import styled from 'styled-components';
import InputField from '../InputField';

import { COLORS, newLayout } from '../../../theme';

export const StyledInputField = styled(InputField)`
  &&& .MuiInputBase-input {
    padding: ${newLayout.spacing.s2};
    font-size: ${newLayout.fontSize.body1};
  }
`;

export const StyledTableWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.text.brightGrey};
  border-radius: ${({ theme }) => theme.borderRadius.secondary};
  background: ${({ theme }) => theme.app.primary};
  font-family: inherit;
  overflow: auto;

  th {
    cursor: default;
  }
`;

export const StyledTableContainer = styled(TableContainer)`
  && {
    border-radius: ${({ theme }) => theme.borderRadius.primary};
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.06);
    align-self: start;
    max-height: 100%;

    &[disabled] {
      pointer-events: none;
    }

    thead > tr:first-child > th:first-child {
      border-top-left-radius: 10px;
    }
    thead > tr:first-child > th:last-child {
      border-top-right-radius: 10px;
    }
    tbody > tr:last-child > td:first-child {
      border-bottom-left-radius: 10px;
    }
    tbody > tr:last-child > td:last-child {
      border-bottom-right-radius: 10px;
    }
  }
`;

export const StyledTable = styled(Table)``;

export const StyledTableBody = styled(TableBody)``;

export const StyledTableHead = styled(TableHead)`
  border-top: none;
`;

export const StyledTableCell = styled(TableCell)`
  && {
    position: relative;
    color: ${COLORS.kinetikBlack};
    border-bottom: 1px solid ${COLORS.black08};
    border-left: 1px solid ${COLORS.black08};
    padding: 16px;
    display: flex;
    align-items: center;

    &:last-child {
      border-right: none;
    }

    &:first-child {
      border-left: none;
    }
  }

  ${StyledTableHead} &&& {
    position: relative;
    padding: 0;
    height: 100%;

    &,
    .MuiTypography-root {
      color: ${COLORS.black60};
      font-size: ${({ theme }) => theme.fontSize.body2};
      font-weight: ${({ theme }) => theme.fontWeight.regular};
      line-height: ${({ theme }) => theme.lineHeight.body2};
    }
  }

  &.MuiTableCell-body {
    overflow: hidden;
  }
`;

export const StyledTableRow = styled(TableRow)`
  position: relative;
  border: 1px solid green !important;
  border: 0 !important;

  ${({ $hasRowClick }) =>
    $hasRowClick &&
    `
    &:hover ${StyledTableCell} {
        background-color: ${COLORS.black04};
    }
    ${StyledTableCell} {
        cursor: pointer;
     }
  `}

  &:first-child ${StyledTableHead} {
    border-bottom: none;
  }

  ${StyledTableHead} &:hover ${StyledTableCell} {
    background-color: unset;
  }

  ${({ $isRowSelected }) =>
    $isRowSelected &&
    `
      ${StyledTableCell} {
      background-color: ${COLORS.oceanGreenLight};
      border-color: ${COLORS.oceanGreen};

      &:not(:last-of-type) {
        border-right-color: ${COLORS.oceanGreenLight};
      }

      &::after {
        position: absolute;
        top: -1px;
        right: -1px;
        left: -1px;
        height: 1px;
        background-color: ${COLORS.oceanGreen};
        content: '';
      }
    }`}
`;

export const PaginationContainer = styled.div`
  width: 100%;
  min-width: ${({ customStyle }) => customStyle?.minWidth || 'max-content'};
  color: #212121;
  overflow: ${({ customStyle }) => customStyle?.overflow || 'hidden'};
  display: grid;
  align-items: center;
  align-self: end;
  justify-content: space-between;
  font-size: 1rem;
  grid-template-columns: max-content 1fr max-content;
  column-gap: ${({ theme }) => theme.spacing.s4};
  margin: ${({ customStyle }) => customStyle?.margin ?? '20px 0 0 0'};
`;
